const constants = require('@/util/constants')
require('./config')

/**
 * 分页获取留言记录
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getLeaveMessages (page, size, successcb, failedcb) {
  axios.get('/api/leavemsg/query', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 标记留言回复
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function replyLeaveMessage (lid, replied, reply, successcb, failedcb) {
  axios.post('/api/leavemsg/reply', {
    lid: lid,
    replied: replied,
    reply: reply,
    client: constants.HTTP_CLIENT
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索过滤历史评价
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterLeaveMessage (page, size, nickname, createdAtStart, createdAtEnd,
  workGroupNickname, agentRealName, client, successcb, failedcb) {
  axios.get('/api/leavemsg/filter', {
    params: {
      'page': page,
      'size': size,
      'nickname': nickname,
      'createdAtStart': createdAtStart,
      'createdAtEnd': createdAtEnd,
      'workGroupNickname': workGroupNickname,
      'agentRealName': agentRealName,
      'client': client
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
